module.exports = __webpack_public_path__ + "static/media/accessories.f587a3bc.svg";